import React, { useEffect, useRef, useState } from "react";
import { animate, useReducedMotion } from "framer-motion";

// Short tabular roll for numerals. The only motion moment on the page.
export const RollingNumber = ({
  value,
  format = (n) => Math.round(n).toLocaleString("en-US"),
  className = "",
  duration = 0.5,
  "data-testid": testId,
}) => {
  const reduce = useReducedMotion();
  const [display, setDisplay] = useState(value);
  const prev = useRef(value);

  useEffect(() => {
    if (reduce) {
      setDisplay(value);
      prev.current = value;
      return;
    }
    const controls = animate(prev.current, value, {
      duration,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(v),
    });
    prev.current = value;
    return () => controls.stop();
  }, [value, reduce, duration]);

  return (
    <span className={`tabular ${className}`} data-testid={testId}>
      {format(display)}
    </span>
  );
};

export default RollingNumber;
